import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./index.css";
import "flowbite";
import { createI18n } from "vue-i18n";

const app = createApp(App);

const messages = {
  fa: require("./locales/fa.json"),
  ar: require("./locales/ar.json"),
  en: require("./locales/en.json"),
};

const getLangFromRoute = () => {
  const path = window.location.pathname;
  if (path.startsWith("/ar")) return "ar";
  if (path.startsWith("/en")) return "en";
  if (path.startsWith("/fa")) return "fa";
  return "fa";
};

const savedLang = localStorage.getItem("languageCode");
const initialLocale = savedLang || getLangFromRoute();

const i18n = createI18n({
  locale: initialLocale,
  fallbackLocale: "fa",
  messages,
  legacy: false,
  globalInjection: true,
});

router.beforeEach((to, from, next) => {
  const lang = to.params.lang || initialLocale;
  if (i18n.locale !== lang) {
    i18n.locale = lang;
    localStorage.setItem("languageCode", lang);
  }
  if (to.meta.requiresAuth) {
    const usertoken = localStorage.getItem("panelToken");
    const authUser = usertoken ? JSON.parse(usertoken) : null;
    if (authUser) next();
    else next({ name: "UserLogin" });
  } else {
    next();
  }
});

app.config.globalProperties.$filters = {
  localNum(value) {
    if (!value) return "0";
    value = Number(value);
    return value.toLocaleString("ar-EG");
  },
  charactersLimit(value, size) {
    if (!value) return "";
    value = value.toString();
    return value.length <= size ? value : value.substr(0, size) + "...";
  },
  charactersLimitTwo(value, size) {
    if (!value) return "";
    value = value.toString();
    return value.length <= size ? value : value.substr(0, size);
  },
};

app.config.productionTip = false;
app.use(router).use(store).use(i18n);
app.mount("#app");
